import { useDataFetch } from './Use-data-fetch';

/**
 * Reglas de alertas e insights.
 *
 * Cada regla define los umbrales de un detector (cuántos intentos fallidos,
 * qué porcentaje de caída, cuántos días de ventana). El motor las lee en cada
 * corrida, así que un cambio aquí aplica sin desplegar nada.
 *
 * Las reglas sembradas (is_default) no se pueden eliminar, sólo desactivar:
 * si se borraran, el motor quedaría sin nada que evaluar y el seeding las
 * recrearía en el siguiente arranque.
 */
export const useAlertRules = ({ enabled = true } = {}) => {
  const { getData, postData, putData, patchData, deleteData, invalidateQuery } =
    useDataFetch();

  const refresh = () => {
    invalidateQuery(['alert-rules']);
    invalidateQuery(['alerts']);
    invalidateQuery(['alerts-summary']);
  };

  const { data, isLoading, error } = getData(
    ['alert-rules'],
    '/alerts/rules',
    { enabled }
  );

  const createMutation = postData('/alerts/rules', {}, { onSuccess: refresh });
  const updateMutation = putData('/alerts/rules', {}, { onSuccess: refresh });
  const toggleMutation = patchData('/alerts/rules', {}, { onSuccess: refresh });
  const removeMutation = deleteData('/alerts/rules', {}, { onSuccess: refresh });

  return {
    rules: data?.data ?? [],
    isLoading,
    error,

    createRule: (payload) => createMutation.mutateAsync(payload),
    updateRule: (id, payload) => updateMutation.mutateAsync({ id, ...payload }),
    // El endpoint es PATCH /alerts/rules/:id/toggle; patchData arma la URL
    // con body.id, así que el sufijo va ahí.
    toggleRule: (id) => toggleMutation.mutateAsync({ id: `${id}/toggle` }),
    removeRule: (id) => removeMutation.mutateAsync(id),

    isSaving:
      createMutation.isPending ||
      updateMutation.isPending ||
      toggleMutation.isPending ||
      removeMutation.isPending,
    saveError:
      createMutation.error ||
      updateMutation.error ||
      toggleMutation.error ||
      removeMutation.error,
  };
};
